import { render } from "./headermenu.vue?vue&type=template&id=cc2c1456&scoped=true"
import script from "./headermenu.vue?vue&type=script&lang=js"
export * from "./headermenu.vue?vue&type=script&lang=js"

import "./headermenu.vue?vue&type=style&index=0&id=cc2c1456&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2c1456"]])

export default __exports__